module.exports = __webpack_public_path__ + "static/img/pre-pos-teste-campanha.8764a2fe.png";